import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=e96397f2&scoped=true"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=e96397f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96397f2",
  null
  
)

export default component.exports